/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BlogManagerGetImageResponse } from './BlogManagerGetImageResponse';

export type BlogManagerGetImageResponseApiRespoonse = {
    data?: BlogManagerGetImageResponse;
    status?: BlogManagerGetImageResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace BlogManagerGetImageResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

